import { render, staticRenderFns } from "./ContactDialogDelete.vue?vue&type=template&id=10f28882&scoped=true&"
import script from "./ContactDialogDelete.vue?vue&type=script&lang=js&"
export * from "./ContactDialogDelete.vue?vue&type=script&lang=js&"
import style0 from "./ContactDialogDelete.vue?vue&type=style&index=0&id=10f28882&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f28882",
  null
  
)

export default component.exports